import type { EonSparkVersion } from '@repo/api-gw-sdk';

export interface CreateJobTemplateWizardState {
  workspaceId: string;
  name: string;
  description: string;
  entryPoint: string;
  entryPointArguments: string;
  sparkConfig: { key: string; value: string }[];
  environmentVariables: { key: string; value: string }[];
  retryEnabled: boolean;
  maxRetries: number;
  cooldownInterval: number;
  jobTimeout: string;
  driverDiskSize: string;
  executorDiskSize: string;
  eonSparkVersionsEnabled: boolean;
  eonSparkVersions: EonSparkVersion[];
  isUpdateMode: boolean;
  templateId: string;
}

export const defaultCreateJobTemplateWizardState: CreateJobTemplateWizardState =
  {
    workspaceId: '',
    name: '',
    description: '',
    entryPoint: '',
    entryPointArguments: '',
    sparkConfig: [{ key: '', value: '' }],
    environmentVariables: [{ key: '', value: '' }],
    retryEnabled: false,
    maxRetries: 3,
    cooldownInterval: 60,
    jobTimeout: '',
    driverDiskSize: '',
    executorDiskSize: '',
    eonSparkVersionsEnabled: false,
    eonSparkVersions: [],
    isUpdateMode: false,
    templateId: '',
  };
